const dialogButtonStyle = {
  cancelButton: {
    padding: "6px 25px"
  },
  completeButton: {
    padding: "6px 25px"
  },
  buttonArea: {
    height: 64
  }
};

export default dialogButtonStyle;
